import {ApolloClient} from 'apollo-client';
import {ApolloLink} from 'apollo-link';
import namespace from '../../../upi/namespace';
import httpLink from './httpLink';
import timeoutLink from './timeoutLink';
import errorLink from './errorLink';
import authLink from './authLink';
import logLink from './logLink';
import stateLink, {cache} from './stateLink';
import StorageProvider from './storageProvider';
import gql from 'graphql-tag';

let cacheRestorePromise = Promise.resolve();

function setupApollo ( client, cache ) {
    // restore defaults upon client reset
    client.onResetStore( stateLink.writeDefaults );
    // resource -> https://github.com/apollographql/apollo-cache-persist/issues/34#issuecomment-371177206
    // -> check user state for changes OR if features.MiniCart is false

    cacheRestorePromise = StorageProvider.init( cache );
    window.addEventListener( 'pagehide', StorageProvider.teardown, {once: true} );
}

export function waitForApolloCacheRestore () {
    return cacheRestorePromise;
}

export function resetApolloStore () {
    return StorageProvider.reset( client );
}

export const client = (function () {
    let _client = namespace( '__APOLLO_CLIENT__' );
    if ( _client.instance ) {
        return _client.instance;
    }

    let links = [];

    if ( process.env.NODE_ENV !== 'production' ) {
        // log api requests to console
        links = links.concat( [logLink] );
    }

    // common links used across all environment configurations
    links = links.concat( [errorLink, authLink, timeoutLink, stateLink] );

    if ( process.env.MOCK_API == 1 ) {
        require( '@services/mocks' );
        const MockProvider = require( './mockProvider' ).default;
        const provider = new MockProvider();

        _client.instance = provider.createClient( {
            cache,
            // connectToDevTools: true,
            link: ApolloLink.from( links )
        } )
    }
    else {
        _client.instance = new ApolloClient( {
            cache,
            link: ApolloLink.from( links.concat( [httpLink] ) )
        } );
    }

    // Prime the @client cache with initial values
    // note -> this is required to prevent "Invariant Violation" errors caused when attempting to
    // read from the cache before the initial values have been set
    _client.instance.mutate( {
        mutation: gql`
            mutation InitializeCartStatus {
                setCartStatus(input: { isUpdating: false }) @client
            }
        `
    } );

    setupApollo( _client.instance, cache );

    return _client.instance;
}());


